export const tokenName = 'getphy_token';
export const tokenExpiryStorage = 'getphy_token_expiry';
export const tokenIATStorage = 'token_iat';
export const tokenEXPStorage = 'token_exp';

export const DEFAULT_COST_LIST = [{ name: 'type', values: ['ADDIT_INSURANCE'] }];
